import { render } from "./AboutModal.vue?vue&type=template&id=05f0c6c7"
import script from "./AboutModal.vue?vue&type=script&lang=js"
export * from "./AboutModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__